import React from 'react'
import styled from 'styled-components'

const Label = (props) => <StyledLabel {...props}>{props.children}</StyledLabel>

export default Label

const StyledLabel = styled.label`
  display:block;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;
  text-transform: uppercase;
  ${({ color }) => (color ? `color: ${color};` : `color: #010101;`)}
  ${({ fontSize }) =>
    fontSize ? `font-size: ${fontSize};` : `font-size: 12px;`}
  ${({ fontWeight }) =>
    fontWeight ? `font-weight: ${fontWeight};` : `font-weight: bold;`}
  ${({ lineHeight }) =>
    lineHeight ? `line-height: ${lineHeight};` : `line-height: 12px;`}
  ${({ align }) => (align ? `text-align: ${align};` : `text-align: center;`)}
`



// WEBPACK FOOTER //
// ./src/components/Label/index.js